module.exports = __webpack_public_path__ + "assets/img/btn-view-pedigree-chart-e96713b3.png";